import React, { useState, useEffect, Dispatch, SetStateAction, useMemo } from 'react';
import { IngredientItem } from 'components/customComponents/Layers/InputGroups';
import ELayersView from 'enums/ELayersView';
import 'components/customComponents/Layers/SelectIngredients.scss';
import { GetScreenList, isNullOrUndefined } from 'utils/Global';
import { ScreenDTO } from 'business/models/Models';
import { withTabBackButton } from 'components/tab';
import { useLayersContainerContext } from 'components/commandpanel/Layers/hooks';
import { getTreeNodeIdsByType } from 'components/commandpanel/Layers/utils';
import ETreeNodeTypes from 'enums/ETreeNodeTypes';
import LoadingDiv from 'components/generic/loadingDiv';

interface Props {
  setContentView: (...args) => void;
  setSelectedScreen: (...args) => void;
  handleBackToPreviousScreen: (contentView: ELayersView) => () => void;
  setHandleOnTabBackPress: Dispatch<SetStateAction<(...args) => void>>;
}

function SelectScreen(props: Props) {
  const {
    setContentView,
    setSelectedScreen,
    handleBackToPreviousScreen,
    setHandleOnTabBackPress,
  } = props;
  const { treeControlState } = useLayersContainerContext();
  const treeNodeScreenIds = getTreeNodeIdsByType(
    treeControlState.treenodes,
    ETreeNodeTypes.Screen,
  );
  const [searchScreen, setSearchScreen] = useState('');
  const globalScreens: ScreenDTO[] = GetScreenList();
  const screenList = useMemo(() => {
    if (!treeNodeScreenIds?.size) {
      return [];
    }
    return globalScreens
      .filter((screen) => treeNodeScreenIds.has(screen.id))
      .filter((screen) =>
        screen.name?.toLowerCase().includes(searchScreen.toLowerCase()),
      );
  }, [globalScreens, treeNodeScreenIds, searchScreen]);

  useEffect(() => {
    setHandleOnTabBackPress(() =>
      handleBackToPreviousScreen(ELayersView.LAYERDESIGNVIEW),
    );
  }, [setHandleOnTabBackPress]);

  function selectScreen(screen: ScreenDTO) {
    setSelectedScreen(screen);
    setContentView(ELayersView.EDITSCREEN);
    setHandleOnTabBackPress(() => handleBackToPreviousScreen(ELayersView.SELECTSCREEN));
  }

  function changeSearchIngredient(e) {
    setSearchScreen(e.target.value);
  }

  if (treeControlState?.isLoading) {
    return (
      <div className="m-4">
        <LoadingDiv />
      </div>
    );
  }

  return (
    <div id="selectscreen-wrapper" className="select-ingredients-tabs">
      <div
        id="selectscreen-searchbar-wrapper"
        className="flex flex-space-between"
        style={{ padding: '1.45% 4.36%' }}
      >
        <input
          id="selectscreen-searchbar-input"
          type="text"
          placeholder="Search Screen"
          style={{ width: '100%', padding: '1.25% 2.34%', height: '30px' }}
          value={searchScreen}
          onChange={changeSearchIngredient}
        />
      </div>
      <div id="selectscreen-ingredients-container" className="ingredients-container">
        {isNullOrUndefined(screenList)
          ? null
          : screenList.map((screen) => (
              <IngredientItem
                text={screen.name}
                key={screen.id}
                onClick={() => selectScreen(screen)}
              />
            ))}
      </div>
    </div>
  );
}

export default withTabBackButton(SelectScreen);
